<template>
  <div>
    <TheDarkModeSwitcher />
    <div class="block grid-cols-2 md:grid">
      <LoginLeftSide />
      <LoginForm />
    </div>
  </div>
  <ToastsContainer />
</template>

<script>
import TheDarkModeSwitcher from '../../layouts/dark-mode-switcher/TheDarkModeSwitcher.vue'
import ToastsContainer from '../../layouts/main-layout/ToastsContainer.vue'
import LoginForm from './LoginForm.vue'
import LoginLeftSide from './LoginLeftSide.vue'

/**
 * Login page, as Funeral Manager's: the logo on the left, over the red
 * triangles of the body background, and the form on the right.
 */
export default {
  name: 'LoginPage',
  components: {
    TheDarkModeSwitcher,
    ToastsContainer,
    LoginForm,
    LoginLeftSide
  },
  mounted() {
    document.body.classList.remove('main', 'error-page')
    document.body.classList.add('login')
  }
}
</script>
